import React from 'react';
import {
    Box,
    Chip,
    Grid, Typography,
} from "@material-ui/core";
import {Alert} from '@material-ui/lab';
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';
import useStyles from '../../styles/styles';
import theme from '../../styles/theme';
import RenderInput from './RenderInput';
import _ from 'lodash';

const PanelBox = ({panelData, trafficClasses, editView, inputs, data, handleFilterChange, handleInputChange, handleSwitchChange, setInputs, nextPromoId = null, rowCol = 4, subKey = null}) => {
    const classes = useStyles();
    const {title, arr, perRow} = panelData;

    return (
        <Grid item xs={rowCol} className={trafficClasses.panelGrid}>
            <Box className={`${classes.filterBox} ${trafficClasses.panelBox}`} style={{marginTop: 0}}>
                <Chip
                    label={title}
                    className={classes.filterSectionLabels}
                />
                <Box style={{ marginBottom: '10px'}}>
                    {editView && nextPromoId && title === 'LEGACY' ? (
                        <Alert severity={"warning"}>
                            <Typography variant="body1">
                                The next available promo id is <strong>{nextPromoId}</strong>
                            </Typography>
                        </Alert>
                    ) : null}
                </Box>
                <Box className={trafficClasses.sectionBox}>
                    {arr.map(item => {
                        const {key, label, type } = item;
                        let dataKey = inputs && Object.keys(inputs).length && subKey ? inputs[subKey][key] : inputs[key];
                        return (
                            <Box width={`${100 / perRow}%`} key={key} className={trafficClasses.sectionItem}>
                                <strong>{label}</strong>
                                {!editView ? (
                                    <>
                                        {type === 'switch' ? (
                                            <>
                                                {dataKey ? (
                                                    <CheckIcon style={{color: theme.palette.success.main}}/>
                                                ) : (
                                                    <ClearIcon style={{color: theme.palette.error.main}}/>
                                                )}
                                            </>
                                        ) : (
                                            <span>{_.isNil(dataKey) || dataKey === '' ? 'N/A' : dataKey}</span>
                                        )}
                                    </>
                                ) : (
                                    <RenderInput
                                        item={item}
                                        disabled={item.disabled || false}
                                        value={dataKey}
                                        data={data}
                                        handleFilterChange={handleFilterChange}
                                        handleInputChange={handleInputChange}
                                        handleSwitchChange={handleSwitchChange}
                                        setInputs={setInputs}
                                        inputs={inputs}
                                        subKey={subKey}
                                    />
                                )}
                            </Box>
                        );
                    })}
                </Box>
            </Box>
        </Grid>
    );
};

export default PanelBox;
